import users from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { isEmployeeLedByCurrent } from 'modules/teams/store/isEmployeeLedByCurrent'

// FIXME: Is this frontend or backend responsability
const OWNED = 'owned'
const EVERYBODY = 'everybody'
const REPORTEES = 'reportees'
const TEAM_LEADER = 'team_leader'

export const isEditable = (
  editableField: string,
  contractVersions: ContractVersions,
  employee?: Employee
) => {
  if (editableField.includes(EVERYBODY)) {
    return true
  }

  const currentEmployee = users.current.employee
  const isCurrentEmployee = currentEmployee === employee

  if (isCurrentEmployee && editableField.includes(OWNED)) {
    return true
  }

  if (employee?.isManagedByCurrent() && editableField.includes(REPORTEES)) {
    return true
  }

  if (
    employee &&
    currentEmployee &&
    isEmployeeLedByCurrent(teams, memberships, currentEmployee.id, employee, contractVersions) &&
    editableField.includes(TEAM_LEADER)
  ) {
    return true
  }

  return false
}

export const isVisible =
  (employee: Employee | null | undefined, contractVersions: ContractVersions) =>
  (visible: string[]) => {
    if (visible.includes(EVERYBODY)) {
      return true
    }

    const currentEmployee = users.current.employee
    const isCurrentEmployee = currentEmployee === employee

    if (isCurrentEmployee && visible.includes(OWNED)) {
      return true
    }

    if (employee?.isManagedByCurrent() && visible.includes(REPORTEES)) {
      return true
    }

    if (
      employee &&
      currentEmployee &&
      isEmployeeLedByCurrent(teams, memberships, currentEmployee.id, employee, contractVersions) &&
      visible.includes(TEAM_LEADER)
    ) {
      return true
    }

    return false
  }
